import React from 'react';
import { useReveal } from '../hooks/useReveal';

const SKILLS = [
  {
    icon: '🧠',
    title: 'Machine Learning & AI',
    tags: [
      'Python', 'PyTorch', 'TensorFlow', 'Computer Vision',
      'CNNs', 'Transformers', 'ResNets', 'U-Nets', 'Scikit-learn',
    ],
  },
  {
    icon: '⚙️',
    title: 'Software Engineering',
    tags: [
      '.NET Core', 'Java', 'Angular', 'Spring Boot',
      'REST APIs', 'Microservices',
    ],
  },
  {
    icon: '📊',
    title: 'Data Science',
    tags: [
      'Predictive Modeling', 'Data Mining', 'Statistical Analysis',
      'Pandas', 'NumPy', 'SQL',
    ],
  },
  {
    icon: '☁️',
    title: 'Cloud & DevOps',
    tags: ['GCP', 'Docker', 'Firebase', 'CI/CD', 'Git', 'Agile'],
  },
];

export default function Skills() {
  const ref = useReveal(0.1);

  return (
    <section className="section" id="skills" ref={ref}>
      <div className="container">
        <div className="section__header">
          <span className="label reveal">Skills &amp; Expertise</span>
          <h2 className="section-title reveal reveal-delay-1">What I work with</h2>
          <div className="section-divider reveal reveal-delay-2" aria-hidden="true" />
        </div>

        <div className="skills__grid">
          {SKILLS.map((skill, i) => (
            <div
              key={skill.title}
              className={`skill-card reveal reveal-delay-${i + 2}`}
            >
              <span className="skill-card__icon" aria-hidden="true">
                {skill.icon}
              </span>
              <h3 className="skill-card__title">{skill.title}</h3>
              <div className="skill-tags">
                {skill.tags.map(tag => (
                  <span key={tag} className="skill-tag">{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
